export default __webpack_public_path__ + "static/pricing-b1216ea8173e8eb9a6abf566774c8801.webp";